<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div>
    <ng-container *ngIf="chatBox">
        <div class="repliedTo">
            <div class="box">
                <div>
                    <span class="replyTitle">
                        {{replyingName | titlecase }}
                    </span>
                    <span class="replyTitle">
                        {{replyingToTiming| date : "MMMM d, y, h:mm a"}}
                    </span>
                    <i class="flaticon-close" (click)="cancel(chatBox)"></i>
                </div>
                <span markdown [data]="replyingto" class="repliedMessage">
                    {{ replyingto }}
                </span>
            </div>
        </div>
    </ng-container>
    <div *ngIf="showFile" class="docker">
        <div class="docBox" *ngFor="let  file of uploadFile, let  i = index">
            <logzy-img-loader [src]="'/assets/images/icons/file-type/'+file?.extension+'.svg'">
            </logzy-img-loader>
            <div class="docDetails">
                <span class="docName">{{file?.original_filename}}.{{file?.extension}}</span>
                <span class="docSize">{{readableFileSize(file?.size)}}</span>
            </div>
            <i class="flaticon-close" (click)="removeDoc(i)" [matTooltip]="'Cancel document'"
                matTooltipPosition="below"></i>
        </div>
    </div>


</div>